export default __webpack_public_path__ + "static/media/dryers.0350ba42.png";